export default "__VITE_ASSET__BefEswY4__"